import { MeasureType } from '@/common/constants';
import { ContractStatusesEnum } from '@/common/constants/contract.statuses';
import { Button } from '@/components/ui/button';
import { generatePDF } from '@/features/loads/components/general/generateFile.ts';
import { usePartyStore } from '@/features/parties/store/usePartyStore';
import useStore from '@/lib/store';
import { FC, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { EditContract } from '../edit-contract';

interface IProps {
  load: any;
}

export const GeneralData: FC<IProps> = ({ load }) => {
  const { t } = useTranslation();
  const { cropTypes, cropGenerations } = usePartyStore();
  const { user } = useStore();

  const isDeleted =
    load?.farmer_contract_status === ContractStatusesEnum.DELETED ||
    load?.farmer_contract_status === ContractStatusesEnum.CANCELED;

  const selectedType = useMemo(
    () => cropTypes?.find((type) => type.value == load?.crop_type_id)?.label,
    [cropTypes, load],
  );

  const selectedGeneration = useMemo(
    () =>
      cropGenerations?.find((type) => type.value == load?.crop_generation_id)
        ?.label,
    [cropGenerations, load],
  );

  const list = useMemo(() => {
    return [
      {
        title: t('stir.receiving'),
        value: load?.buyer_tin || '---',
        span: 'col-span-1',
      },
      {
        title: t('name.product.receiving'),
        value: load?.buyer_name || '---',
        span: 'col-span-2',
      },
      {
        title: t('stir.delivery'),
        value: load?.tax_number || '---',
        span: 'col-span-1',
      },
      {
        title: t('name.product.delivery'),
        value: load?.farmer_name || '---',
        span: 'col-span-2',
      },
      {
        title: t('selection.type'),
        value: selectedType || '---',
        span: 'col-span-1',
      },
      {
        title: t('generation'),
        value: selectedGeneration || '---',
        span: 'col-span-1',
      },
      {
        title: t('cultivated.area'),
        value: load?.area ? `${load?.area} ${t('he')}` : '---',
        span: 'col-span-1',
      },
    ];
  }, [load, selectedType, selectedGeneration]);

  return (
    <div className="grid grid-cols-6 gap-6 w-full">
      {list?.map((item) => (
        <div key={item.title} className={item.span}>
          <p className="text-sm text-gray-600 mb-1">{item.title}:</p>
          <p className="text-base font-medium">{item.value}</p>
        </div>
      ))}
      <div className="col-span-1">
        <div className="flex items-center gap-3">
          {(load?.current_status === MeasureType.WEIGH_IN ||
            load?.current_status === MeasureType.WEIGH_OUT ||
            load?.current_status === MeasureType.ANALYSIS) && <EditContract />}

          <div className="flex flex-col">
            <p className="text-sm text-gray-600 mb-1">
              {t('contract.number')}:
            </p>
            <p className="text-base font-medium">
              {load?.contract_number || '---'}
            </p>
          </div>
        </div>
      </div>
      <Button
        variant="outline"
        disabled={isDeleted}
        onClick={() =>
          generatePDF(
            load!,
            user!,
            load?.number,
            load?.improved_cotton,
            load?.created_at,
            load,
          )
        }
        className="col-span-1"
      >
        {t('2xl.download')}
      </Button>
    </div>
  );
};
